module.exports = __webpack_public_path__ + "img/pic_15.816f09fd.jpg";